import {
	FlagCA,
	FlagDE,
	FlagDK,
	FlagEUColor,
	FlagFI,
	FlagIN,
	FlagNO,
	FlagNZ,
	FlagPL,
	FlagSE,
	FlagWorld
} from '@comeon/vectors';

export const selectorTextKeys = ['ALTER_YOUR_LANGUAGE_SETTINGS', 'MOBILE_METHOD_CONTINUE'];
export const proposeTextKeys = ['SWITCH_LANGUAGE_BUTTON', 'SWITCH_LANGUAGE_TEXT', 'SWITCH_LANGUAGE_CANCEL'];

export const FLAGS = {
	da_DK: FlagDK,
	de_DE: FlagDE,
	en_AU: FlagWorld,
	en_CA: FlagCA,
	en_EU: FlagEUColor,
	en_IN: FlagIN,
	en_NZ: FlagNZ,
	en_ON: FlagCA,
	en_XX: FlagWorld,
	es_CL: FlagWorld,
	eu_NO: FlagEUColor,
	fi_FI: FlagFI,
	no_NO: FlagNO,
	pl_PL: FlagPL,
	sv_GU: FlagSE,
	sv_SE: FlagSE
};
